import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PageHeader } from "@excoleadershipui/pionweblib";
import { Link, useLocation } from "react-router-dom";
// material ui
import { Stack, Box } from "@mui/material";
// icons
import CancelIcon from "@mui/icons-material/Cancel";
// components
import AddApiManagement from "./AddApiManagement";
import UpdateApiManagement from "./UpdateApiManagement";
import { MuiDataGrid, GridCellExpand, Notifier, ErrorNotifier, CommonCurdPopUp } from "../../../../components";
import ConfirmDialog from "../../../../components/common/ConfirmDialog";
import Layout from "../../../../layout/Layout";
// redux
import {

  getApiManagementChr,
  deleteApiManagementChr,
  rowSelect,
  resetMessage,
  resetErrMessage,
} from "../../../../features/iam_chr/application_management/apiManagementSlice";

// ----------------------------------------------------------------------------------

const ApiManagement = () => {
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const location = useLocation()
  const dispatch = useDispatch();
  const { message, errMessage, apiManagementData, selectedData } =
    useSelector((state) => ({ ...state.apiManagementChr }));

  function getAppName(value,  params) {
    return params?.name.split(".")[0]
  }

  function getModuleName(value,  params) {
    return params?.name.split(".").length > 2 ? params?.name.split(".")[1] : ""
  }

  function getSubModuleName(value,  params) {
    return params?.name.split(".").length > 3 ? params?.name.split(".")[2] : ""
  }

  function getFeatureName(value,  params) {
    return params?.name.split(".").length > 4 ? params?.name.split(".")[3] : ""
  }

  function getServiceName(params) {
    return <GridCellExpand value={params?.row?.name.split(".")[params?.row?.name.split(".").length - 1]} />
  }

  function renderCellExpand(params) {
    return (
      <GridCellExpand
        value={params.value || ""}
        width={params.colDef.computedWidth}
      />
    );
  }

  const data = {
    rows: apiManagementData,
    columns: [
      { field: "applicationName", headerName: "Application Name", width: 180, valueGetter: getAppName },
      { field: "moduleName", headerName: "Module Name", width: 180, valueGetter: getModuleName },
      { field: "subModuleName", headerName: "Sub Module Name", width: 180, valueGetter: getSubModuleName },
      { field: "featureName", headerName: "Feature Name", width: 180, valueGetter: getFeatureName },
      { field: "serviceName", headerName: "Service Name", width: 280, renderCell: getServiceName },
      { field: "url", headerName: "URL", width: 250, renderCell: renderCellExpand },
      { field: "comments", headerName: "Comments", width: 250, renderCell: renderCellExpand },
    ],
  };

  useEffect(() => {
    dispatch(getApiManagementChr());
  }, []);

  const handleSetConfirmDialog = (obj) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: obj.isOpen,
    });
  };

  const handleDelete = () => {
    let data = {
      id: selectedData?.id,
    };
    dispatch(deleteApiManagementChr(data)).then((res) => {
      if (res?.payload?.data?.ok) {
        setTimeout(() => {
          dispatch(resetMessage());
          setConfirmDialog({
            ...confirmDialog,
            isOpen: false,
          });
          dispatch(getApiManagementChr());
        }, 2000);
      }
      if (res?.payload?.error) {
        setTimeout(() => {
          dispatch(resetErrMessage());
        }, 3000);
      }
    });
  };

  return (
    <>
     
        <>
          <Stack flexDirection="row" justifyContent="space-between">
            {/* <Box sx={{ width: "100%" }}>
              <PageHeader variant="pageHeader">API Management</PageHeader>
            </Box> */}
            {/* <Link to="/exco/iam/app-services" state={{ l3Menu: location?.state?.l3Menu }}>
              <CancelIcon color="red" />
            </Link> */}
          </Stack>
          <MuiDataGrid
            // setShowAdd={location?.state?.permissions?.find((e) => e.applicationService?.name?.split(".")[e?.applicationService?.name?.split(".")?.length - 1] === "create") ? () => setShowAdd(true) : null}
            // setShowEdit={location?.state?.permissions?.find((e) => e.applicationService?.name?.split(".")[e?.applicationService?.name?.split(".")?.length - 1] === "update") ? () => setShowEdit(true) : null}
            // setShowDelete={location?.state?.permissions?.find((e) => e.applicationService?.name?.split(".")[e?.applicationService?.name?.split(".")?.length - 1] === "delete") ? () =>
            //   setConfirmDialog({
            //     isOpen: true,
            //     title: "Are you sure to delete this record?",
            //     subTitle: "You can't undo this operation",
            //     onConfirm: () => handleDelete(),
            //   }) : null
            // }

            setShowAdd={() => setShowAdd(true)}
            setShowEdit={() => setShowEdit(true)}
            setShowDelete={() =>
              setConfirmDialog({
                isOpen: true,
                title: "Are you sure to delete this record?",
                subTitle: "You can't undo this operation",
                onConfirm: () => handleDelete(),
              })
            }

            toolbarColumn={true}
            // toolbarFilter = {true}
            toolbarDensity={true}
            toolbarExport={true}
            data={data}
            select={(data) => dispatch(rowSelect(data))}
          />
        </>
      


      {showAdd && <CommonCurdPopUp
        heading={`Create Api Management`}
        mediumScreen={true}
        close={
          () => setShowAdd(false)
        }
      >
        <AddApiManagement close={
          () => setShowAdd(false)
        } />

      </CommonCurdPopUp>}

      {showEdit && <CommonCurdPopUp
        heading={`Update Api Management`}
        mediumScreen={true}
        close={
          () => setShowEdit(false)
        }
      >
        <UpdateApiManagement close={
          () => setShowEdit(false)
        } />

      </CommonCurdPopUp>}




      {showEdit && (
        <UpdateApiManagement
          showEdit={showEdit}
          close={() => setShowEdit(false)}
        />
      )}
      <ConfirmDialog
        confirmDialog={confirmDialog}
        setConfirmDialog={(obj) => handleSetConfirmDialog(obj)}
      />
      {message && <Notifier message={message} />}
      {errMessage && <ErrorNotifier message={errMessage} />}
    </>
  );
};

export default ApiManagement;
